import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { PageNotFoundComponent } from './features/page-not-found/page-not-found.component';
import { CustomAuthGuard } from './core/guards/custom-auth.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./features/homepage/homepage.component').then(
        (mod) => mod.HomepageComponent
      ),
  },
  {
    path: 'login',
    pathMatch: 'full',
    loadComponent: () =>
      import('./features/homepage/homepage.component').then(
        (mod) => mod.HomepageComponent
      ),
  },
  {
    path: 'billing',
    loadComponent: () =>
      import('./features/dashboard/billing/billing.component').then((mod) => mod.BillingComponent)
  },
  {
    path: 'faq',
    loadComponent: () =>
      import('./features/dashboard/faq/faq.component').then((mod) => mod.FaqComponent),
  },

  {
    path: 'home-sales-refinancing',
    loadComponent: () =>
      import('./features/home-sales-refinancing/home-sales-refinancing.component').then(
        (mod) => mod.HomeSalesRefinancingComponent
      ),
    canActivate: [CustomAuthGuard],
  },

  {
    path: 'battery-solutions',
    loadComponent: () =>
      import('./features/battery-solutions/battery-solutions.component').then(
        (mod) => mod.BatterySolutionsComponent
      ),
  },

  {
    path: 'forms',
    loadComponent: () =>
      import('./features/dashboard/forms/forms.component').then((mod) => mod.FormsComponent),
    canActivate: [CustomAuthGuard],
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./features/privacy-policy/privacy-policy.component').then(
        (mod) => mod.PrivacyPolicyComponent
      ),
  },
  {
    path: 'monitoring',
    loadComponent: () =>
      import('./features/monitoring/monitoring.component').then(
        (mod) => mod.MonitoringComponent
      ),
    canActivate: [CustomAuthGuard],
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./features/dashboard/dashboard.component').then(
        (mod) => mod.DashboardComponent
      ),
    canActivate: [CustomAuthGuard],
  },
  {
    path: 'tsr-form',
    loadComponent: () =>
      import('./features/dashboard/tsr-form/tsr-form.component').then(
        (mod) => mod.TsrFormComponent
      ),
    canActivate: [CustomAuthGuard],
  },
  {
    path: 'careers',
    loadComponent: () =>
      import('./features/careers/careers.component').then((mod) => mod.CareersComponent),
  },
  {
    path: 'licenses',
    loadComponent: () =>
      import('./features/licenses/licenses.component').then(
        (mod) => mod.LicensesComponent
      ),
  },
  {
    path: 'get-in-touch',
    loadComponent: () =>
      import('./features/dashboard/contact-us/contact-us.component').then(
        (mod) => mod.ContactUsComponent
      ),
  },
  {
    path: 'service-charges',
    loadComponent: () =>
      import('./features/service-charges/service-charges.component').then(
        (mod) => mod.ServiceChargesComponent
      ),
  },
  {
    path: 'environmental-commodities-markets',
    redirectTo: 'pro'
  },
  {
    path: 'fleet-management',
    loadComponent: () =>
      import('./features/fleet-management/fleet-management.component').then(
        (mod) => mod.FleetManagementComponent
      ),
  },
  {
    path: 'about',
    loadComponent: () =>
      import('./features/about/about.component').then((mod) => mod.AboutComponent),
  },
  {
    path: 'pro',
    loadComponent: () =>
      import('./features/pro/pro.component').then((mod) => mod.ProComponent),
  },
  {
    path: 'spruce-servicing',
    redirectTo: 'pro'
  },
  {
    path: 'page-not-found',
    loadComponent: () =>
      import('./features/page-not-found/page-not-found.component').then(
        (mod) => mod.PageNotFoundComponent
      ),
  },

  {
    path: 'portal-faq',
    loadComponent: () =>
      import('./features/dashboard/faq/portal-faq/portal-faq.component').then(
        (mod) => mod.PortalFaqComponent
      ),
  },

  {
    path: 'user-settings',
    loadComponent: () =>
      import('./features/user-settings/user-settings.component').then(
        (mod) => mod.UserSettingsComponent
      ),
    canActivate: [CustomAuthGuard],
  },

  {
    path: 'life-events',
    loadComponent: () =>
      import('./features/life-events/life-events.component').then(
        (mod) => mod.LifeEventsComponent
      ),
  },

  {
    path: 'lifeevents',
    redirectTo: 'life-events',
    pathMatch: 'full',
  },

  {
    path: 'life-events/refinance',
    loadComponent: () =>
      import('./features/life-events/life-events-refinance/life-events-refinance.component').then(
        (mod) => mod.LifeEventsRefinanceComponent
      ),
  },

  {
    path: 'life-events/form/solar-agreement-amendment-request',
    loadComponent: () =>
      import('./features/life-events/forms/solar-agreement-amendment-request/solar-agreement-amendment-request.component').then(
        (mod) => mod.SolarAgreementAmendmentRequestComponent
      ),
  },

  {
    path: 'life-events/form/system-purchase-or-prepayment-request',
    loadComponent: () =>
      import('./features/life-events/forms/system-purchase-or-prepayment-request/system-purchase-or-prepayment-request.component').then(
        (mod) => mod.SystemPurchaseOrPrepaymentRequestComponent
      ),
  },

  {
    path: 'life-events/form/refinance-information-request',
    loadComponent: () =>
      import('./features/life-events/forms/refinance-informaiton-request/refinance-information-request.component').then(
        (mod) => mod.RefinanceInformationRequestComponent
      ),
  },
  {
    path: 'life-events/form/success-message',
    loadComponent: () =>
      import('./features/life-events/forms/success-message/success-message.component').then(
        (mod) => mod.SuccessMessageComponent
      ),
  },
  {
    path: 'home-sales',
    loadComponent: () =>
      import('./features/life-events/forms/home-sales/home-sales.component').then(
        (mod) => mod.HomeSalesComponent
      )
  },
  {
    path: 'job-openings',
    loadComponent: () =>
      import('./features/careers/job-openings/job-openings.component').then(
        (mod) => mod.JobOpeningsComponent
      ),
  },

  {
    path: 'job',
    loadComponent: () =>
      import('./features/careers/job-application/job-application.component').then(
        (mod) => mod.JobApplicationComponent
      ),
  },

  {
    path: '**',
    loadComponent: () =>
      import('./features/page-not-found/page-not-found.component').then(
        (mod) => mod.PageNotFoundComponent
      ),
  },
];
